import { useEffect } from "react";

import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import useLocalization from "../../hooks/useLocalization";

import Date from "../elements/Date";
import Delete from "../elements/Delete";
import EditorToolbar from "../editors/EditorToolbar";
import { format, parse } from "date-fns";

const Availability = ({ value, label, onChange, onSave, message, width }) => {
  const theme = useTheme();

  const { getLabel, getMessage } = useLocalization();

  const handleAdd = () => {
    let newValue = [...value, { startsOn: null, endsOn: null }];

    onChange(newValue);
  };

  const handleChange = (index, field, newValue) => {
    let yyyymmdd = format(newValue, "yyyy-MM-dd");
    let newAvailability = [];

    for (let x = 0; x < value.length; x++) {
      if (x !== index) {
        newAvailability.push(value[x]);
        continue;
      }

      newAvailability.push({ ...value[x], [field]: yyyymmdd });
    }

    onChange(newAvailability);
  };

  const handleDelete = (index) => {
    let newAvailability = [];
    for (let x = 0; x < value.length; x++) {
      if (x !== index) {
        newAvailability.push(value[0]);
      }
    }

    onChange(newAvailability);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      border="1px solid #ccc"
      borderRadius="5px"
    >
      {label ? <Typography align="center">{label}</Typography> : null}
      <EditorToolbar
        onAdd={handleAdd}
        onSave={onSave}
      />

      {value.length > 0 ? (
        <Box padding="8px">
          {value.map((dates, index) => (
            <Box
              key={`availability_${index}`}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              gap={1}
            >
              <Date
                label={getLabel("startsOn")}
                value={dates.startsOn}
                onChange={(newValue) =>
                  handleChange(index, "startsOn", newValue)
                }
              />
              <Date
                label={getLabel("endsOn")}
                value={dates.endsOn}
                onChange={(newValue) => handleChange(index, "endsOn", newValue)}
              />

              <Delete
                id={index}
                onDelete={handleDelete}
              />
            </Box>
          ))}
        </Box>
      ) : (
        <Box sx={{ padding: "8px" }}>
          <Typography variant="overline">{getMessage("notSet")}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default Availability;
